import { GetDigest, UpdateDigest } from '@front-app/api-generated/digests-api';
import { ApiDigestResponse } from '../model';

export const isFullDigestResponse = (_: ApiDigestResponse | GetDigest | UpdateDigest): _ is ApiDigestResponse => Object.hasOwnProperty.call(_, 'id')
	&& Object.hasOwnProperty.call(_, 'groupId');
